
export const MetaEventName = {
    websiteAccess: "Accès au site web",
    submissionRequest: "Formulaire demande soumission"
}
